import React from "react";
import HomeBanner from "./HomeBanner";
import HomeServicesCard from "./HomeServicesCard";

const MainHome = () => {
  return (
    <div>
      <HomeBanner />
      <HomeServicesCard />
    </div>
  );
};

export default MainHome;
